import { createNamespace } from '@interhyp/platform-value';
/* stored values specified by and for the module-interest-check
 */
export const moduleInterestCheckNamespace = createNamespace({
    id: Symbol('module-interest-check'),
    acronym: 'mic',
});
/* all the user input concerning its mortgage intent (in calculators or mortgage request form)
 * all values are defined here in the directory mortgageIntent
 */
export const mortgageIntentNamespace = createNamespace({
    id: Symbol('mortgage-intent'),
    acronym: 'mi',
});
/* everything that needs to be handled for standalone applications to work properly
 */
export const standaloneAppNamespace = createNamespace({
    id: Symbol('standalone-applications'),
    acronym: 'sta',
});
/* space for configuration based information. Config Entries as well as configurationd-definitioins
 */
export const configurationNamespace = createNamespace({
    id: Symbol('configuration-service'),
    acronym: 'con',
});
/* space for home portal based information like layout, search or navigation
 */
export const portalNamespace = createNamespace({
    id: Symbol('portal'),
    acronym: 'hp',
});
/* space for interim portal based information like last viewed / current intent
 */
export const portalInterimNamespace = createNamespace({
    id: Symbol('portal-interim'),
    acronym: 'hpi',
});
